// Add your custom JS here.
import simpleParallax from 'simple-parallax-js';

let image = document.getElementsByClassName('parallax');
new simpleParallax(image, {
    'scale': 1.5
});

const navEl = document.querySelector('.navbar');
window.addEventListener('scroll', () => {
    if (window.scrollY >= 56) {
        navEl.classList.add('bg-dark');
        navEl.classList.add('shadow');
    }
    if (window.scrollY < 56) {
        navEl.classList.remove('bg-dark');
        navEl.classList.remove('shadow');
    }
})

let items = document.querySelectorAll('.portfolio.carousel .carousel-item')

items.forEach((el) => {
    const minPerSlide = 4
    let next = el.nextElementSibling
    for (let i=1; i<minPerSlide; i++) {
        if (!next) {
            // wrap carousel by using first child
            next = items[0]
        }
        let cloneChild = next.cloneNode(true)
        el.appendChild(cloneChild.children[0])
        next = next.nextElementSibling
    }
})